export const colinks = {
  meta: {
    name: 'Default'
  }
};
